import { PlusReviewImageItem } from '@/services/types/review.type';
import { create } from 'zustand';

// 리뷰 정보 타입 정의
export interface ReviewInfo {
  isContract: boolean;
  isEdit: boolean;
  reviewId: number;
  point: number;
  author: string;
  content: string;
  images: PlusReviewImageItem[];
}

interface ReviewInfoState {
  isContract: boolean;
  isEdit: boolean;
  reviewId: number;
  point: number;
  author: string;
  content: string;
  images: PlusReviewImageItem[];
  getReviewInfo: () => ReviewInfo;
  setReviewId: (reviewId: number) => void;
  setPoint: (point: number) => void;
  setAuthor: (author: string) => void;
  setContent: (content: string) => void;
  setImages: (images: PlusReviewImageItem[]) => void;
}

export const useReviewInfoStore = create<ReviewInfoState>((set, get) => ({
  isContract: false,
  isEdit: false,
  reviewId: 0,
  point: 0,
  author: '',
  content: '',
  images: [],
  setIsContract: (isContract: boolean) => set({ isContract }),
  setIsEdit: (isEdit: boolean) => set({ isEdit }),
  setReviewId: (reviewId: number) => set({ reviewId }),
  setPoint: (point: number) => set({ point }),
  setAuthor: (author: string) => set({ author }),
  setContent: (content: string) => set({ content }),
  setImages: (images: PlusReviewImageItem[]) => set({ images }),
  getReviewInfo: () => ({
    isContract: get().isContract,
    isEdit: get().isEdit,
    reviewId: get().reviewId,
    point: get().point,
    author: get().author,
    content: get().content,
    images: get().images,
  }),
}));
